import React from 'react';
import { FieldType } from 'types/FieldTypes';
import FormModal from 'components/modals/FormModal';
import { SCHEDULING_COLOR_OPTIONS } from './schedulingConstants';

// Rename the name of the function:
const EditActivityRecurrenceForm: React.FC<{
    viewKey?: string,
    linkedItem?: { [key: string]: string | number }
}> = ({ viewKey, linkedItem }) => {

    const apiObject = 'activity_recurrence';

    // Configure the recurrence fields, changes apply from the linked occurrence date onwards
    const fields: FieldType[] = [
        {
            type: 'dropdown',
            name: 'time_type',
            label: 'timerow.general.type_label',
            apiRequest: [{
                endpoint: 'get_non_productive_timetype_list',
                object: 'non_productive_timetype',
                params: { is_active: true },
                useCache: true
            }],
            disabled_selected: 'timerow.general.type_disabled_selected',
            allowNoneOption: false,
            showSearch: false,
        },
        {
            type: 'textarea',
            name: 'note',
            label: 'timerow.general.note_label',
            rows: 3,
            isNote: true,
            placeholder: 'timerow.general.note_placeholder',
        },
        {
            type: 'time',
            name: 'start_time',
            label: 'timerow.general.start_time_label',
            width: '50%',
            group: 'field-row-time',
        },
        {
            type: 'time',
            name: 'end_time',
            label: 'timerow.general.end_time_label',
            width: '50%',
            group: 'field-row-time',
        },
        {
            type: 'dropdown',
            name: 'frequency',
            label: 'timerow.general.frequency_label',
            hardcodedOptions: [
                { value: 'daily', name: 'timerow.general.frequency_daily' },
                { value: 'weekly', name: 'timerow.general.frequency_weekly' },
                { value: 'monthly', name: 'timerow.general.frequency_monthly' },
                { value: 'yearly', name: 'timerow.general.frequency_yearly' },
            ],
            allowNoneOption: false,
            showSearch: false,
        },
        {
            name: 'weekdays',
            label: 'timerow.general.select_weekdays_label',
            tooltipText: 'timerow.general.select_weekdays_tooltipText',
            type: 'multi-tabs',
            fullWidth: true,
            defaultValue: ['monday', 'tuesday', 'wednesday', 'thursday', 'friday'],
            dependentOn: { fieldName: 'frequency', value: 'daily' },
            hardcodedOptions: [
                { value: "monday", name: "date_time.days.short.monday" },
                { value: "tuesday", name: "date_time.days.short.tuesday" },
                { value: "wednesday", name: "date_time.days.short.wednesday" },
                { value: "thursday", name: "date_time.days.short.thursday" },
                { value: "friday", name: "date_time.days.short.friday" },
                { value: "saturday", name: "date_time.days.short.saturday" },
                { value: "sunday", name: "date_time.days.short.sunday" },
            ],
        },
        {
            type: 'dropdown',
            name: 'end_type',
            label: 'timerow.general.end_type_label',
            hardcodedOptions: [
                { value: 'never', name: 'timerow.general.end_type_never' },
                { value: 'on_date', name: 'timerow.general.end_type_on_date' },
                { value: 'after_count', name: 'timerow.general.end_type_after_count' },
            ],
            defaultValue: { value: 'never' },
            allowNoneOption: false,
            showSearch: false,
            dependentOn: { fieldName: 'end_type', notValue: ['on_date', 'after_count'] },
        },
        {
            // Same field as above, but taking half the row once a date or count is revealed next to it
            type: 'dropdown',
            name: 'end_type',
            label: 'timerow.general.end_type_label',
            hardcodedOptions: [
                { value: 'never', name: 'timerow.general.end_type_never' },
                { value: 'on_date', name: 'timerow.general.end_type_on_date' },
                { value: 'after_count', name: 'timerow.general.end_type_after_count' },
            ],
            allowNoneOption: false,
            showSearch: false,
            width: '50%',
            group: 'field-row-end',
            dependentOn: { fieldName: 'end_type', value: ['on_date', 'after_count'] },
        },
        {
            type: 'date',
            name: 'end_date',
            label: 'timerow.general.end_date_label',
            width: '50%',
            group: 'field-row-end',
            dependentOn: { fieldName: 'end_type', value: 'on_date' },
        },
        {
            type: 'number',
            name: 'occurrence_count',
            label: 'timerow.general.occurrence_count_label',
            placeholder: 'timerow.general.occurrence_count_placeholder',
            min: 1,
            width: '50%',
            group: 'field-row-end',
            dependentOn: { fieldName: 'end_type', value: 'after_count' },
        },
        {
            name: 'custom_color',
            label: 'timerow.general.color_label',
            type: 'tabs',
            showIconOnly: true,
            customClass: "label",
            options: SCHEDULING_COLOR_OPTIONS,
        },
    ];

    return (
        <FormModal
            viewKey={viewKey}
            apiObject={apiObject}
            fields={fields}
            linkedItem={linkedItem}
            showDeleteButton={true}
            deleteConfig={{
                apiUrl: 'delete_activity_recurrence',
                data: { effective_from: linkedItem?.effective_from },
                tooltipText: 'scheduling.other_activity.delete_recurrence_tooltip',
            }}
        />
    );
};

export default EditActivityRecurrenceForm;
